import { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
export var Locale;
(function (Locale) {
  Locale["enUS"] = "en";
  Locale["zhCN"] = "zh-CN";
  Locale["zhTW"] = "zh-TW";
  Locale["ar"] = "ar";
  Locale["de"] = "de";
  Locale["es"] = "es";
  Locale["fr"] = "fr";
  Locale["id"] = "id";
  Locale["ja"] = "ja";
  Locale["ko"] = "ko";
  Locale["ms"] = "ms";
  Locale["pt"] = "pt";
  Locale["ru"] = "ru";
  Locale["th"] = "th";
  Locale["tr"] = "tr";
  Locale["vi"] = "vi";
})(Locale || (Locale = {}));
export function useTranslators() {
  var intl = useIntl();
  var locale = useMemo(function () {
    if (!intl.locale) {
      return Locale.enUS;
    }
    return intl.locale;
  }, [intl.locale]);
  var $st = useCallback(function (id, values) {
    return intl.formatMessage({
      id: id,
      defaultMessage: id
    }, values);
  }, [intl]);
  var $stn = useCallback(function (value, precision) {
    var num = Number(value) || 0;
    var option = {};
    if (precision !== undefined) {
      option.maximumFractionDigits = precision;
      option.minimumFractionDigits = precision;
    } else if (num >= 100) {
      option.maximumFractionDigits = 2;
      option.minimumFractionDigits = 2;
    } else if (num >= 1) {
      option.maximumFractionDigits = 4;
      option.minimumFractionDigits = 4;
    } else {
      option.maximumSignificantDigits = 4;
    }
    return intl.formatNumber(value, option);
  }, [intl]);
  return useMemo(function () {
    return {
      locale: locale,
      $st: $st,
      $stn: $stn
    };
  }, [locale, $st, $stn]);
}